import { useQuery } from "@apollo/client";
import { GET_PENDING_LEADERBOARDS } from "./usePendingLeaderboard.gql";
import {
    GetPendingLeaderboardsQuery,
    GetPendingLeaderboardsQueryVariables,
} from "./usePendingLeaderboard.gql.types";
import { useBindToChannelEvent } from "components/providers/Realtime/useBindToChannelEvent";
import { useEventChannel } from "components/routes/events/id/EventProvider";

export type PendingLeaderboardFields = NonNullable<NonNullable<NonNullable<GetPendingLeaderboardsQuery["eventDivision"]>["leaderboards"]>[number]>

export function usePendingLeaderboard({
    eventDivisionId,
    round,
}: {
    eventDivisionId: string;
    round: number;
}) {
    const query = useQuery<
        GetPendingLeaderboardsQuery,
        GetPendingLeaderboardsQueryVariables
    >(GET_PENDING_LEADERBOARDS, {
        variables: {
            eventDivisionId,
            round,
        },
        skip: round === undefined || !eventDivisionId,
        fetchPolicy: "cache-and-network",
    });

    useBindToChannelEvent<{ event_division_id: string; round: number }>(
        useEventChannel(),
        "leaderboard-updated",
        (msg) => {
            if (
                msg.event_division_id === eventDivisionId &&
                msg.round === round
            ) {
                query.refetch();
            }
        },
    );

    const leaderboard = query.data?.eventDivision?.leaderboards?.[0];
    const leaderboardWithPending =
        query.data?.eventDivision?.leaderboardsWithPending?.[0];

    return {
        leaderboard,
        leaderboardWithPending,
        query,
    };
}
